import { Theme } from '@/theme';
import styled from 'styled-components';
import { ScreenWrapper } from '@CS/app/App.styles';

export const LoginScreen = styled(ScreenWrapper)`
  background-color: ${Theme.color.lightPurple};
  background-blend-mode: soft-light;

  background-image: radial-gradient(
    79.23% 20.32% at 50% 51.95%,
    rgb(255 255 255 / 0.5) 0%,
    rgb(255 255 255 / 0) 100%
  );

  padding: 0px 5px;
`;

export const Logo = styled.img`
  height: auto;
  width: 100%;
`;

export const InfoDescription = styled.p`
  margin: 20px auto 50px;
  color: ${Theme.color.white};
  text-align: center;
  width: 68.2%;

  line-height: 1.35;
  font-size: 16px;
`;
